import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'react-emotion';
import ImageViewer from 'components/image-viewer';
import Page from 'structure/page';
import {
  getProductById,
  getProductImageUrl,
  getProductPriceString
} from 'service/products';
import { PRODUCT_THUMBNAIL_CLICK } from 'util/events';

const PositionBox = styled('div')({
  display: 'flex',
  justifyContent: 'center',
}, ({ theme }) => ({
  ...theme.media.desktop({
    float: 'right',
    display: 'block',
    marginLeft: '5px',
  })
}));

class Product extends Component {
  constructor(props) {
    super(props);
    this.productId = this.props.match.params['product'];
    this.state = { };
  }

  componentDidMount() {
    getProductById(this.productId)
      .then(product => {
        this.setState({
          product,
        });
      });
  }

  renderPendingPage = () => (
    <Page {...this.props}>
      <p>Loading...</p>
    </Page>
  );

  renderProductPage = (product) => (
    <Page {...this.props} title={product.name}>
      <PositionBox>
        <ImageViewer
          width="240px"
          height="300px"
          images={product.images.map(image => ({
            full: getProductImageUrl(image, 'med'),
            thumb: getProductImageUrl(image, 'thumb'),
          }))}
          onThumbnailClick={(index) => this.props.onEvent(PRODUCT_THUMBNAIL_CLICK(product, index))}
        />
      </PositionBox>
      <p>{getProductPriceString(product)} <Link to='/store'>Return to list</Link></p>
      <p>{product.description}</p>
    </Page>
  );

  render() {
    const { product } = this.state;
    return product ? this.renderProductPage(product) : this.renderPendingPage();
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/pages/product/product.js